import axios from 'axios'
import { useState, useEffect } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";
import Select from "react-select";

function BankReconcilation({adminData}) {

    const [showForm, setShowForm] = useState(false);
     const [chargeMaster, setChargeMaster] = useState([]);
     const [editingCompanyId, setEditingCompanyId] = useState(null);
      const [isEditMode, setIsEditMode] = useState(false);
   const [showModal, setShowModal] = useState(false);
const [selectedRowId, setSelectedRowId] = useState(null);
const [clearedDate, setClearedDate] = useState("");
  
   
   const [form, setForm] = useState({
      schedule_name: '',
      title: '',
      type:''
    })
  

    const [searchTerm, setSearchTerm] = useState('');
      const [account, setAccount] = useState([]);
      const [selectedAccount, setSelectedAccount] = useState(null);
       const [data, setData] = useState([]);
  
    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
      setToast({ show: true, message: msg, bg });
    };
  
    const handleAddClick = () => {
      setShowForm(true);
    };
  
  const handleUpdateClick = (row) => {
  setSelectedRowId(row.id);
  setClearedDate("");
  setShowModal(true);
};
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    };
  
  
 
    

  const fetchAccountDetail = async () => {
    try {
        const resParty = await axios.get(
            "https://api.skyguard.group/api/fetch-account"
        );

        const result = resParty.data.result;

        const filter = result
            .filter(
                acc =>
                    (acc.party_id === 0 || acc.party_id == null) &&
                    acc.type_account?.trim().toUpperCase() === "BANK ACCOUNT"
            )
            .map(acc => ({
                value: acc.id,         
                label: acc.holder_name, 
            }));

        setAccount(filter);
    } catch (error) {
        console.log(error);
    }
};
    
  
    useEffect(() => {
  fetchAccountDetail();
  
    }, []);
  
      const handleEdit = (form) => {
  
      setForm({
        id: form.id || '',
        schedule_name: form.schedule_name || '',
         title: form. title || '',
         type:form.type || ""
     
      });
      setEditingCompanyId(form.id);
      setIsEditMode(true);
      setShowForm(true);
    };
  
 const handleSubmit = async () => {
    try {
        const res = await axios.get(
            "https://api.skyguard.group/api/fetch-bank-account",
            {
                params: {
                    account_id: selectedAccount?.value
                }
            }
        );

        console.log(res.data);
        setData(res.data);
    } catch (error) {
        console.log(error);
    }
};


const saveClearedDate = async () => {
  try {
    await axios.put(
      "https://api.skyguard.group/api/update-cleared-date-account",
      {
        id: selectedRowId,
        cleared_date: clearedDate,
        cleared_by:adminData.user.id,
      }
    );

  
    showToast("Updated Successfully",'success');

    setShowModal(false);

      await handleSubmit();
  } catch (error) {
    console.log(error);
  
    showToast("Updation Failed",'danger');
  }
};

  
  

  return (
  <>
     <div className='main-section'>
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <ToastNotification
            show={toast.show}
            message={toast.message}
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
          />
          <h3 className='my-3 fw-bold fs-5 golos'>Bank Re-concilation</h3>



          <div className="mb-3 d-flex flex-wrap align-items-end justify-content-start ">

            <div className="mb-2 w-50 w-md-50 pe-md-2">
                <Select
        options={account}
        value={selectedAccount}
        onChange={(selected) => setSelectedAccount(selected)}
        placeholder="Select Account"
    />
            </div>

          <button
    className="btn btn-primary mb-2"
    onClick={handleSubmit}
>
    Seacrh
</button>
          </div>


         




          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>

              <thead className='table-info'>
                <tr>
                   <th scope='col'>Voucher No</th>
                              <th scope='col'>Action</th>
                 
                  <th scope='col'>Voucher Date</th>
                  <th scope='col'>Name</th>
                    <th scope='col'>Cheque No</th>
            <th scope='col'>Cheque Date</th>
            <th scope='col'>Amount </th>
            <th scope='col'>Cleared On</th>
      
                </tr>
              </thead>
       <tbody>
  {data?.map((item) => {
    let tableRows = [];

    try {
      let parsed = JSON.parse(item.tableRow);

      // Handle double-stringified JSON
      if (typeof parsed === "string") {
        parsed = JSON.parse(parsed);
      }

      tableRows = Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      console.log("Invalid tableRow JSON:", err);
    }

    const accountNames = tableRows
      .map((row) => row?.account?.label)
      .filter(Boolean)
      .join(", ");

    const voucherPrefix =
      item.payment_type === "bank_payment"
        ? "BP"
        : item.payment_type === "bank_receipt"
        ? "BR"
        : "";

    return (
      <tr key={item.id}>
        <td>
          {voucherPrefix}/{item.inv_no}/{item.branchName}
        </td>

        <td>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => handleUpdateClick(item)}
          >
          Update
          </button>
        </td>

        <td>
          {item.payment_date
            ? new Date(item.payment_date).toLocaleDateString("en-GB")
            : "-"}
        </td>

        <td>{accountNames || "-"}</td>

        <td>{item.cheque_no || "-"}</td>

        <td>
          {item.cheque_date &&
          item.cheque_date !== "0000-00-00 00:00:00"
            ? new Date(item.cheque_date).toLocaleDateString("en-GB")
            : "-"}
        </td>

        <td>{Number(item.amount).toFixed(2)}</td>

        <td>
          {item.cleared_date
            ? new Date(item.cleared_date).toLocaleDateString("en-GB")
            : "-"}
        </td>
      </tr>
    );
  })}
</tbody>
            </table>
          </div>


{showModal && (
  <div
    className="modal d-block"
    tabIndex="-1"
    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">
            Update Cleared Date
          </h5>

          <button
            type="button"
            className="btn-close"
            onClick={() => setShowModal(false)}
          />
        </div>

        <div className="modal-body">
          <label>Cleared Date</label>

          <input
            type="date"
            className="form-control"
            value={clearedDate}
            onChange={(e) =>
              setClearedDate(e.target.value)
            }
          />
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-success"
            onClick={saveClearedDate}
          >
            Save
          </button>
        </div>

      </div>
    </div>
  </div>
)}
        
        </div>
      </div>
  </>
  )
}

export default BankReconcilation